import { Datagrid, EditButton, List, ListActions, ReferenceField, ShowButton, SimpleList, TextField } from "react-admin";
import { useMediaQuery } from "@mui/material";
import { checkPermission } from "server/security/utils";
import permissions from "app/permissions";
import { getPermissions } from "auth/security/securityUtils";
import SecuredComponent from "server/security/SecuredComponent";
import { administrationRequests } from "api/administrationApi";
import { MOBILE_BREAKPOINT } from "utils/constants";
import { settings } from "app";
import { MobileListRow } from "features/MobileListRow";

const ListClinic = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);

  return (
    <List
      title="Клиники"
      exporter={false}
      actions={<ListActions hasCreate={checkPermission(getPermissions(), permissions.canManageClinics)} />}
    >
      {isMobile ? (
        <SimpleList
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => (
            <MobileListRow fields={[{ label: "Има на български", value: record?.nameBg }]} />
          )}
          secondaryText={record => (
            <div>
              <MobileListRow fields={[{ label: "Има на английски", value: record?.nameEn }]} />
              <MobileListRow
                fields={[
                  {
                    label: "Катедра",
                    value: (
                      <ReferenceField
                        source="departmentId"
                        reference={administrationRequests.getDepartmentsSelect()}
                        sortable={false}
                      >
                        <TextField source="fullName" />
                      </ReferenceField>
                    ),
                  },
                ]}
              />
              <MobileListRow
                fields={[
                  {
                    label: "Болница",
                    value: (
                      <ReferenceField
                        source="hospitalityId"
                        reference={administrationRequests.getHospitalitiesSelect()}
                        sortable={false}
                      >
                        <TextField source="nameBg" />
                      </ReferenceField>
                    ),
                  },
                ]}
              />
            </div>
          )}
          tertiaryText={() => (
            <>
              <SecuredComponent permission={permissions.canManageClinics}>
                <EditButton label="" />
              </SecuredComponent>
              <SecuredComponent permission={permissions.canPreviewClinics}>
                <ShowButton label="" />
              </SecuredComponent>
            </>
          )}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
        >
          <TextField
            source="nameBg"
            label="Има на български"
            sortable={false}
          />
          <TextField
            source="nameEn"
            label="Има на английски"
            sortable={false}
          />
          <ReferenceField
            source="departmentId"
            reference={administrationRequests.getDepartmentsSelect()}
            label="Катедра"
            sortable={false}
          >
            <TextField source="fullName" />
          </ReferenceField>
          <ReferenceField
            source="hospitalityId"
            reference={administrationRequests.getHospitalitiesSelect()}
            label="Болница"
            sortable={false}
          >
            <TextField source="nameBg" />
          </ReferenceField>
          <SecuredComponent permission={permissions.canManageClinics}>
            <EditButton />
          </SecuredComponent>
          <SecuredComponent permission={permissions.canPreviewClinics}>
            <ShowButton />
          </SecuredComponent>
        </Datagrid>
      )}
    </List>
  );
};
export default ListClinic;
